import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Button, Popconfirm, Divider, message } from 'antd';
import cloneDeep from 'lodash.clonedeep';
import LoadingPage from '../../../components/LoadingPage';
import { db } from '../../../config/Fire';
import * as Constants from './../../../constants/nodes_database';
import PlacesAdminComponent from '../../../components/PlacesAdminComponent';
import PlaceInfo from '../../../components/PlaceInfo';
import FormNewPlace from '../../../components/FormNewPlace';

const addTypes = {
    EMPTY: "",
    ADD_COUNTRY: "ADD_COUNTRY",
    ADD_PROVINCE: "ADD_PROVINCE",
    ADD_CITY: "ADD_CITY"
}

const PlacesAdmin = ({ onExitPlaces }) => {

    const [places, setPlaces] = useState(null);
    const [isEmptyPlaces, setIsEmptyPlaces] = useState(false);
    const [countries, setCountries] = useState(null);
    const [provinces, setProvinces] = useState(null);
    const [provincesNewPlace, setProvincesNewPlace] = useState(null);
    const [cities, setCities] = useState(null);
    const [countrySelected, setCountrySelected] = useState(null);
    const [provinceSelected, setProvinceSelected] = useState(null);
    const [citySelected, setCitySelected] = useState(null);
    const [isSavingPlaces, setIsSavingPlaces] = useState(null);
    const [isEditingCity, setIsEditingCity] = useState(null);
    const [addType, setAddType] = useState(addTypes.EMPTY);

    const getPlaces = () => {
        if(!places) {
            db.ref(`${Constants.PLACES}`).once("value")
                .then((snapshot) => {
                    if(snapshot.exists() && snapshot.val() !== null) {
                        var places = snapshot.val();
                        var countries = Object.keys(places);
                        setPlaces(places)
                        setCountries(countries)
                    } else {
                        message.error('No hay lugares cargados');
                        setPlaces(null)
                        setCountries(null)
                        setIsEmptyPlaces(true)
                    }
                })
                .catch(err => {
                    console.log("error: " + err);
                    message.error('No se pudieron traer los datos, intente nuevamente');
                });
            return (<LoadingPage />);
        }
    }

    const onCountrySelected = value => {
        var provinces = [];
        if(places && places[value] && places[value]["provinces"]) {
            places[value]["provinces"].forEach(province => {
                provinces.push(province["name"]);
            });
            setProvinces(provinces)
            setCountrySelected(value)
            setProvinceSelected(null)
            setCitySelected(null)
            setAddType(addTypes.EMPTY)
            setIsEditingCity(false)
        }
    }

    const onProvinceSelected = value => {
        var cities = [];
        if(places && places[countrySelected] && places[countrySelected]["provinces"]) {
            places[countrySelected]["provinces"].forEach(province => {
                if(province["name"] === value && province["cities"]) {
                    province["cities"].forEach(city => {
                        cities.push(city["name"]);
                    });
                }
            });
            setCities(cities)
            setProvinceSelected(value)
            setCitySelected(null)
            setAddType(addTypes.EMPTY)
            setIsEditingCity(false)
        }
    }

    const onCitySelected = value => {
        if(places && places[countrySelected] && places[countrySelected]["provinces"]) {
            places[countrySelected]["provinces"].forEach(province => {
                if(province["name"] === provinceSelected && province["cities"]) {
                    province["cities"].forEach(city => {
                        if(city["name"] === value) {
                            setCitySelected(city)
                            setAddType(addTypes.EMPTY)
                            setIsEditingCity(false)
                        }
                    });
                }
            });
        }
    }

    const removeCountry = () => {
        const places2 = cloneDeep(places);
        if(places2 && places2[countrySelected]) {
            delete places2[countrySelected];
            setIsSavingPlaces(true)
            return db.ref().update({
                places: places2
            })
            .then(() => {
                message.success('¡Los cambios se guardaron exitósamente!');
                var countries = Object.keys(places2);
                setPlaces(places2)
                setCountries(countries)
                setProvinces(null)
                setCities(null)
                setIsSavingPlaces(false)
                setCountrySelected(null)
                setProvinceSelected(null)
                setCitySelected(null)
            })
            .catch(err => {
                console.log("not found save data");
                setIsSavingPlaces(false)
            });
        }
    }

    const removeProvince = () => {
        const places2 = cloneDeep(places);
        var indexToRemove = -1;
        if(places2 && places2[countrySelected] && places2[countrySelected]["provinces"]) {
            places2[countrySelected]["provinces"].forEach((province, index) => {
                if(province && province["name"] === provinceSelected) {
                    indexToRemove = index;
                }
            });
            if(indexToRemove !== -1) {
                places2[countrySelected]["provinces"].splice(indexToRemove, 1);
                if(places2[countrySelected]["provinces"].length === 0) {
                    delete places2[countrySelected];
                }
                setIsSavingPlaces(true)
                return db.ref().update({
                    places: places2
                })
                .then(() => {
                    message.success('¡Los cambios se guardaron exitósamente!');
                    var countries = Object.keys(places2);
                    setPlaces(places2)
                    setCountries(countries)
                    setProvinces(null)
                    setCities(null)
                    setIsSavingPlaces(false)
                    setCountrySelected(null)
                    setProvinceSelected(null)
                    setCitySelected(null)
                })
                .catch(err => {
                    console.log("not found save data");
                    setIsSavingPlaces(false)
                });
            }
        }
    }

    const removeCity = () => {
        const places2 = cloneDeep(places);
        var indexProvince = -1
        var indexToRemove = -1;
        if(places2 && places2[countrySelected] && places2[countrySelected]["provinces"]) {
            places2[countrySelected]["provinces"].forEach((province, indexProv) => {
                if(province && province["name"] === provinceSelected && province["cities"]) {
                    indexProvince = indexProv;
                    province["cities"].forEach((city, index) => {
                        if(city && city["name"] === citySelected["name"]) {
                            indexToRemove = index;
                        }
                    });
                }
            });
            if(indexProvince !== -1 && indexToRemove !== -1) {
                places2[countrySelected]["provinces"][indexProvince]["cities"].splice(indexToRemove, 1);
                setIsSavingPlaces(true)
                return db.ref().update({
                    places: places2
                })
                .then(() => {
                    message.success('¡Los cambios se guardaron exitósamente!');
                    var countries = Object.keys(places2);
                    setPlaces(places2)
                    setCountries(countries)
                    setProvinces(null)
                    setCities(null)
                    setIsSavingPlaces(false)
                    setCountrySelected(null)
                    setProvinceSelected(null)
                    setCitySelected(null)
                })
                .catch(err => {
                    console.log("not found save data");
                    setIsSavingPlaces(false)
                });
            }
        }
    }

    const onCountrySelectedNewPlace = value => {
        var provincesByCountry = [];
        var places2 = cloneDeep(places);
        if(places2 && places2[value] && places2[value]["provinces"]) {
            places2[value]["provinces"].forEach(province => {
                provincesByCountry.push(province["name"]);
            });
            setProvincesNewPlace(provincesByCountry)
        }
    }

    const handleExitAddForm = () => {
        setAddType(addTypes.EMPTY)
        setProvincesNewPlace(null)
    }

    const handleSubmitNewPlace = values => {
        const places2 = cloneDeep(places);
        if(/[@#$^&*()_+\-=[\]{};':"\\|,.<>£/?]/.test(values.field_country)) {
            message.error('El país ingresado no puede contener los siguientes caracteres: @#$^&*()_+-=[]{};\':"\\|,.<>£/?.');
        } else {
            if(places2 !== null && addType === addTypes.ADD_COUNTRY && places2[values.field_country] !== undefined) {
                message.error('El país ingresado ya existe. Por favor, ingrese otro o de lo contrario utlice el existente.');
            } else {
                saveNewPlace(values);
            }
        }
    }

    const saveNewPlace = values => {
        var places2 = cloneDeep(places);
        var neighborhoods = [];
        var hitos = [];
        if(values.field_neighborhoods && values.field_neighborhoods.length !== 0) {
            values.field_neighborhoods.forEach(neighborhood => {
                neighborhoods.push({ name: neighborhood });
            });
        }
        if(values.field_hitos && values.field_hitos.length !== 0) {
            values.field_hitos.forEach(hito => {
                hitos.push({ name: hito });
            });
        }
        switch (addType) {
            case addTypes.ADD_COUNTRY:
                if(places2 === null) {
                    places2 = {
                        [values.field_country]: {
                            provinces: [{
                                country: values.field_country,
                                name: values.field_province,
                                cities: [{
                                    country: values.field_country,
                                    province: values.field_province,
                                    postalCode: values.field_postal_code,
                                    name: values.field_city,
                                    hitos: hitos,
                                    neighborhoods: neighborhoods
                                }]
                            }]
                        }
                    }
                } else {
                    places2[values.field_country] = {
                        provinces: [{
                            country: values.field_country,
                            name: values.field_province,
                            cities: [{
                                country: values.field_country,
                                province: values.field_province,
                                postalCode: values.field_postal_code,
                                name: values.field_city,
                                hitos: hitos,
                                neighborhoods: neighborhoods
                            }]
                        }]
                    }
                }
                setIsSavingPlaces(true)
                return db.ref().update({
                    places: places2
                })
                .then(() => {
                    message.success('¡Los cambios se guardaron exitósamente!');
                    var countries = Object.keys(places2);
                    setPlaces(places2)
                    setAddType(addTypes.EMPTY)
                    setCountries(countries)
                    setProvinces(null)
                    setCities(null)
                    setIsSavingPlaces(false)
                    setCountrySelected(null)
                    setProvinceSelected(null)
                    setCitySelected(null)
                })
                .catch(err => {
                    console.log("not found save data");
                    setAddType(addTypes.EMPTY)
                    setIsSavingPlaces(false)
                });
            case addTypes.ADD_PROVINCE:
                places2[values.field_country]["provinces"].push({
                    country: values.field_country,
                    name: values.field_province,
                    cities: [{
                        country: values.field_country,
                        province: values.field_province,
                        postalCode: values.field_postal_code,
                        name: values.field_city,
                        hitos: hitos,
                        neighborhoods: neighborhoods
                    }]
                })
                setIsSavingPlaces(true)
                return db.ref().update({
                    places: places2
                })
                .then(() => {
                    message.success('¡Los cambios se guardaron exitósamente!');
                    var countries = Object.keys(places2);
                    setPlaces(places2)
                    setAddType(addTypes.EMPTY)
                    setCountries(countries)
                    setProvinces(null)
                    setCities(null)
                    setIsSavingPlaces(false)
                    setCountrySelected(null)
                    setProvinceSelected(null)
                    setCitySelected(null)
                })
                .catch(err => {
                    console.log("not found save data");
                    setAddType(addTypes.EMPTY)
                    setIsSavingPlaces(false)
                });
            case addTypes.ADD_CITY:
                var indexProvince = -1
                if(places2 && places2[values.field_country] && places2[values.field_country]["provinces"]) {
                    places2[values.field_country]["provinces"].forEach((province, indexProv) => {
                        if(province && province["name"] === values.field_province) {
                            indexProvince = indexProv;
                        }
                    });
                    if(indexProvince !== -1) {
                        if(places2[values.field_country]["provinces"][indexProvince]["cities"]) {
                            places2[values.field_country]["provinces"][indexProvince]["cities"].push({
                                country: values.field_country,
                                province: values.field_province,
                                postalCode: values.field_postal_code,
                                name: values.field_city,
                                hitos: hitos,
                                neighborhoods: neighborhoods
                            })
                        } else {
                            places2[values.field_country]["provinces"][indexProvince]["cities"] = [{
                                country: values.field_country,
                                province: values.field_province,
                                postalCode: values.field_postal_code,
                                name: values.field_city,
                                hitos: hitos,
                                neighborhoods: neighborhoods
                            }]
                        }
                        setIsSavingPlaces(true)
                        return db.ref().update({
                            places: places2
                        })
                        .then(() => {
                            message.success('¡Los cambios se guardaron exitósamente!');
                            var countries = Object.keys(places2);
                            setPlaces(places2)
                            setAddType(addTypes.EMPTY)
                            setCountries(countries)
                            setProvinces(null)
                            setCities(null)
                            setIsSavingPlaces(false)
                            setCountrySelected(null)
                            setProvinceSelected(null)
                            setCitySelected(null)
                        })
                        .catch(err => {
                            console.log("not found save data");
                            setAddType(addTypes.EMPTY)
                            setIsSavingPlaces(false)
                        });
                    }
                } else {
                    setAddType(addTypes.EMPTY)
                    setIsSavingPlaces(false)
                }
                break;
            default:
                setAddType(addTypes.EMPTY)
                break;
        }
    }

    const renderAddTypeOfPlace = () => {
        switch (addType) {
            case addTypes.EMPTY:
                return(
                    <Row center="xs">
                        <Col xs={0} sm={0} md={3}></Col>
                        <Col xs={4} sm={4} md={2}>
                            <Button onClick={onAddCountry} disabled={isEditingCity}>Agregar país</Button>
                        </Col>
                        <Col xs={4} sm={4} md={2}>
                            <Button onClick={onAddProvince} disabled={isEditingCity}>Agregar provincia</Button>
                        </Col>
                        <Col xs={4} sm={4} md={2}>
                            <Button onClick={onAddCity} disabled={isEditingCity}>Agregar ciudad</Button>
                        </Col>
                        <Col xs={0} sm={0} md={3}></Col>
                    </Row>
                )
            case addTypes.ADD_COUNTRY:
                return(
                    <Row center="xs">
                        <Col>
                            <FormNewPlace onSubmit={handleSubmitNewPlace}
                            provincesNewPlace={provincesNewPlace} countries={countries} onCountrySelectedNewPlace={onCountrySelectedNewPlace}
                            isNewCountry={true} isNewProvince={false} isEditCity={false} isSaving={isSavingPlaces} onExit={handleExitAddForm}/>
                        </Col>
                    </Row>
                )
            case addTypes.ADD_PROVINCE:
                    return(
                        <Row center="xs">
                            <Col>
                                <FormNewPlace onSubmit={handleSubmitNewPlace}
                                provincesNewPlace={provincesNewPlace} countries={countries} onCountrySelectedNewPlace={onCountrySelectedNewPlace}
                                isNewCountry={false} isNewProvince={true} isEditCity={false}
                                isSaving={isSavingPlaces}
                                onExit={handleExitAddForm}/>
                            </Col>
                        </Row>
                    )
            case addTypes.ADD_CITY:
                    return(
                        <Row center="xs">
                            <Col>
                                <FormNewPlace onSubmit={handleSubmitNewPlace}
                                provincesNewPlace={provincesNewPlace} countries={countries} onCountrySelectedNewPlace={onCountrySelectedNewPlace}
                                isNewCountry={false} isNewProvince={false} isEditCity={false}
                                isSaving={isSavingPlaces}
                                onExit={handleExitAddForm}/>
                            </Col>
                        </Row>
                    )
            default:
                break;
        }
    }

    const onAddCountry = () => {
        setAddType(addTypes.ADD_COUNTRY)
    }

    const onAddProvince = () => {
        setAddType(addTypes.ADD_PROVINCE)
    }

    const onAddCity = () => {
        setAddType(addTypes.ADD_CITY)
    }

    const editCity = () => {
        setAddType(addTypes.EMPTY)
        setProvincesNewPlace(null)
        setIsEditingCity(true)
    }

    const renderEditCity = () => {
        if(isEditingCity) {
            return (<Row center="xs">
                <Col>
                    <FormNewPlace onSubmit={handleSubmitEditPlace}
                    provincesNewPlace={provincesNewPlace} countries={countries} onCountrySelectedNewPlace={onCountrySelectedNewPlace}
                    isNewCountry={false} isNewProvince={false} isEditCity={true}
                    countrySelected={countrySelected} provinceSelected={provinceSelected} citySelected={citySelected}
                    isSaving={isSavingPlaces}
                    onExit={handleExitEditForm}/>
                </Col>
            </Row>);
        } else {
            return (
                <Row center="xs">
                    <Col xs={2} sm={2} md={3}></Col>
                    <Col xs={8} sm={8} md={6}>
                        {
                            citySelected ?
                                isSavingPlaces ?
                                    <Button disabled={true} loading>Guardando</Button>
                                    :
                                    <Button disabled={isSavingPlaces} onClick={editCity}>Editar ciudad</Button>
                                :
                                <Button disabled={true}>Editar ciudad</Button>

                        }
                    </Col>
                    <Col xs={2} sm={2} md={3}></Col>
                </Row>
            );
        }
    }

    const handleSubmitEditPlace = values => {
        editPlace(values);
    }

    const editPlace = values => {
        var places2 = cloneDeep(places);
        var indexProvince = -1;
        var neighborhoods = [];
        var hitos = [];
        if(values.field_neighborhoods && values.field_neighborhoods.length !== 0) {
            values.field_neighborhoods.forEach(neighborhood => {
                neighborhoods.push({ name: neighborhood });
            });
        }
        if(values.field_hitos && values.field_hitos.length !== 0) {
            values.field_hitos.forEach(hito => {
                hitos.push({ name: hito });
            });
        }
        if(places2 && places2[values.field_country] && places2[values.field_country]["provinces"]) {
            places2[values.field_country]["provinces"].forEach((province, indexProv) => {
                if(province && province["name"] === values.field_province) {
                    indexProvince = indexProv;
                }
            });
            if(indexProvince !== -1) {
                if(places2[values.field_country]["provinces"][indexProvince] && places2[values.field_country]["provinces"][indexProvince]["cities"]) {
                    var indexCity = -1;
                    places2[values.field_country]["provinces"][indexProvince]["cities"].forEach((city, index) => {
                        if(city.name && city.name === citySelected.name) {
                            indexCity = index;
                        }
                    });
                    if(indexCity !== -1) {
                        places2[values.field_country]["provinces"][indexProvince]["cities"][indexCity] = {
                            country: values.field_country,
                            province: values.field_province,
                            postalCode: values.field_postal_code,
                            name: values.field_city,
                            hitos: hitos,
                            neighborhoods: neighborhoods
                        }
                        setIsSavingPlaces(true)
                        return db.ref().update({
                            places: places2
                        })
                        .then(() => {
                            message.success('¡Los cambios se guardaron exitósamente!');
                            var countries = Object.keys(places2);
                            setPlaces(places2)
                            setAddType(addTypes.EMPTY)
                            setIsEditingCity(false)
                            setCountries(countries)
                            setProvinces(null)
                            setCities(null)
                            setIsSavingPlaces(false)
                            setCountrySelected(null)
                            setProvinceSelected(null)
                            setCitySelected(null)
                        })
                        .catch(err => {
                            console.log("not found save data");
                            message.error('Se produjo un error al guardar. Por favor, intente nuevamente.')
                            setAddType(addTypes.EMPTY)
                            setIsSavingPlaces(false)
                            setIsEditingCity(false)
                        });
                    } else {
                        console.log("4")
                        message.error('No se pudieron guardar los cambios.')
                        setAddType(addTypes.EMPTY)
                        setIsSavingPlaces(false)
                        setIsEditingCity(false)
                    }
                } else {
                    console.log("3")
                    message.error('No se pudieron guardar los cambios.')
                    setAddType(addTypes.EMPTY)
                    setIsSavingPlaces(false)
                    setIsEditingCity(false)
                }
            } else {
                console.log("2")
                message.error('No se pudieron guardar los cambios.')
                setAddType(addTypes.EMPTY)
                setIsSavingPlaces(false)
                setIsEditingCity(false)
            }
        } else {
            console.log("1")
            message.error('No se pudieron guardar los cambios.')
            setAddType(addTypes.EMPTY)
            setIsSavingPlaces(false)
            setIsEditingCity(false)
        }
    }

    const handleExitEditForm = () => {
        setAddType(addTypes.EMPTY)
        setIsEditingCity(false)
    }

    return (
        <div styles={{ width: "100%" }}>
            {
                (places || isEmptyPlaces) ?
                    <Grid styles={{ width: "100%" }}>
                        <Row styles={{ float: 'left' }}>
                            <Col xs={6}>
                                <Button onClick={onExitPlaces}>
                                    Volver
                                </Button>
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col>
                                <PlacesAdminComponent
                                countries={countries} onCountrySelected={onCountrySelected} countrySelected={countrySelected}
                                provinces={provinces} onProvinceSelected={onProvinceSelected} provinceSelected={provinceSelected} 
                                cities={cities} onCitySelected={onCitySelected} citySelected={citySelected}/>
                            </Col>
                        </Row>
                        <Divider>Información de la ciudad</Divider>
                        <Row>
                            <Col>
                                <PlaceInfo city={citySelected}/>
                            </Col>
                        </Row>
                        <Divider>Editar</Divider>
                        {
                            renderEditCity()
                        }
                        <Divider>Borrar</Divider>
                        <Row center="xs">
                            <Col xs={0} sm={0} md={3}></Col>
                            <Col xs={4} sm={4} md={2}>
                                {
                                    (countrySelected && !isEditingCity && addType === addTypes.EMPTY) ?
                                        isSavingPlaces ?
                                            <Button disabled={true} loading>Guardando</Button>
                                            :
                                            <Popconfirm title="¿Desea borrar el país?" okText="SI" cancelText="NO" onConfirm={removeCountry}>
                                                <Button>Borrar país</Button>
                                            </Popconfirm>
                                        :
                                        <Button disabled={true}>Borrar país</Button>
                                }
                            </Col>
                            <Col xs={4} sm={4} md={2}>
                                {
                                    (provinceSelected && !isEditingCity && addType === addTypes.EMPTY) ?
                                        isSavingPlaces ?
                                            <Button disabled={true} loading>Guardando</Button>
                                            :
                                            <Popconfirm title="¿Desea borrar la provincia?" okText="SI" cancelText="NO" onConfirm={removeProvince}>
                                                <Button disabled={isSavingPlaces}>Borrar provincia</Button>
                                            </Popconfirm>
                                        :
                                        <Button disabled={true}>Borrar provincia</Button>

                                }
                            </Col>
                            <Col xs={4} sm={4} md={2}>
                                {
                                    (citySelected && !isEditingCity && addType === addTypes.EMPTY) ?
                                        isSavingPlaces ?
                                            <Button disabled={true} loading>Guardando</Button>
                                            :
                                            <Popconfirm title="¿Desea borrar la ciudad?" okText="SI" cancelText="NO" onConfirm={removeCity}>
                                                <Button disabled={isSavingPlaces}>Borrar ciudad</Button>
                                            </Popconfirm>
                                        :
                                        <Button disabled={true}>Borrar ciudad</Button>

                                }
                            </Col>
                            <Col xs={0} sm={0} md={3}></Col>
                        </Row>
                        <Divider>Agregar</Divider>
                        {
                            renderAddTypeOfPlace()
                        }
                    </Grid>
                    :
                    getPlaces()
            }
        </div>
    );
}

PlacesAdmin.propTypes = {
    onExitPlaces: PropTypes.func.isRequired,
};

export default withRouter(PlacesAdmin);